module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-23.0c69d04.woff2";